// extracted by mini-css-extract-plugin
export var image = "_iu-0";